import { render, staticRenderFns } from "./ItemD.vue?vue&type=template&id=f6338710"
import script from "./ItemD.vue?vue&type=script&lang=js"
export * from "./ItemD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports